// Demonstrate how to register services
// In this case it is a simple constant service.
angular.module('jv.services', []);